export const useStyles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 2,
  },
});
